import { render } from "./LotLayout.vue?vue&type=template&id=476ee1d9&scoped=true"
import script from "./LotLayout.vue?vue&type=script&lang=js"
export * from "./LotLayout.vue?vue&type=script&lang=js"

import "./LotLayout.vue?vue&type=style&index=0&id=476ee1d9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476ee1d9"]])

export default __exports__